var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"success-container"},[_c('h1',[_vm._v(_vm._s(_vm.message))]),_c('img',{attrs:{"src":require("@/assets/icons/ic_success_72x72.svg"),"height":"300","width":"300"}}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',[_vm._v(" You can close this tab now. "),_c('br'),_vm._v(" If you are using the app, we will redirect you shortly ")])
}]

export { render, staticRenderFns }